const features = [
  {
    icon: 'ri-stack-line',
    title: '多平台聚合',
    desc: '一站聚合神马影视、樱花影视、小小影视、久久影视等八大主流平台资源，无需反复切换 APP，海量内容一搜即达。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清流畅',
    desc: '全平台高清画质保障，智能选源引擎自动匹配最佳播放线路，告别卡顿与缓冲，享受影院级观影体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '实时同步各平台最新影视资源，热播剧集上线第一时间即可观看，每日更新量超 500 部，永不错过精彩内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么选择麻花影视？三大核心优势为你解答
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="w-16 h-16 md:w-18 md:h-18 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5">
                <i className={`${feat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}